var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    viewBox: "0 0 64 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.496 4.715A52.294 52.294 0 0 0 40.463.755a40.35 40.35 0 0 0-1.668 3.349 49.375 49.375 0 0 0-14.455 0 33.885 33.885 0 0 0-1.667-3.35A52.816 52.816 0 0 0 9.639 4.727C2.281 15.031-1.043 27.63.287 40.177a52.587 52.587 0 0 0 15.974 7.946 39.808 39.808 0 0 0 3.422-5.464 33.29 33.29 0 0 1-5.386-2.543c.444-.33.889-.66 1.31-.99a37.906 37.906 0 0 0 31.947 0c.432.354.865.684 1.31.99a33.787 33.787 0 0 1-5.387 2.543 37.89 37.89 0 0 0 3.41 5.464 52.613 52.613 0 0 0 15.986-7.934c1.326-12.558-2.007-25.166-9.377-35.474zM21.091 33.026c-2.616.273-5.131-1.077-6.325-3.397a6.232 6.232 0 0 1 .943-7.06 6.396 6.396 0 0 1 7-1.654c2.454.937 4.071 3.274 4.065 5.877-.05 3.435-2.508 6.234-5.683 6.234zm21.002 0c-3.223-.346-5.665-3.039-5.665-6.246 0-3.208 2.442-5.9 5.665-6.247a5.98 5.98 0 0 1 4.162 1.953 5.854 5.854 0 0 1 1.509 4.306c-.074 3.435-2.52 6.234-5.695 6.234h.024z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscut);
export default __webpack_public_path__ + "static/media/discut.d508c3642722819a4dcd90c592a38cb8.svg";
export { ForwardRef as ReactComponent };